const number = process.env.REACT_APP_WHATSAPP_NUMBER;

export const waLink = (message) =>
  `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

export const DEFAULT_WA_MESSAGE =
  "¡Hola Colors Limpieza! Quisiera solicitar una cotización para un servicio en Medellín.";

export const openWhatsApp = (message) => {
  window.open(waLink(message), "_blank", "noopener,noreferrer");
};
